import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { ApiManagerService } from '../api-manager/api.maganer.service';
import { of, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  spId: any = "41343230";
  defaultLid = 214601
  logo: any = '';

  profileSub=new Subject<any>();
  
  constructor(
    private httpClient: HttpClient,
    private api: ApiManagerService
    ) { }

  getPrivateProfile(token: string) {
    if(token){
      const headers = { 
        Authorization: `Bearer ${token}` 
      };
      return this.httpClient.get(`${environment.creatorAdminApi}user/${token}`, { headers }).pipe(
        catchError(err => {
          console.log('getPrivateProfile failed, return default lid', err);
          return of({lid:214601})
        })
      );
      // return this.httpClient.get(this.api.getApi() + `ba2/user/${token}`);
    }else{
      return this.httpClient.get(this.api.getApi() + `designer/user/${this.defaultLid}`);
    }
  }

  getPublicProfile() {
    return this.httpClient.get(`${environment.spooortsSportApi}sporthero/${this.spId}/profile/public`);
  }

  getProfileTitles() {
    return this.httpClient.get<SingleValue[]>(`${environment.spooortsEventApi}users/salutations`).pipe(
      map(values => values.map(v => v.value))
    );
  }

}

export interface SingleValue {
  value: string;
}
